<script setup lang="ts">
/** Rounded textarea matching SofaxInput; label above, hint or error below. */
const props = withDefaults(defineProps<{
  label?: string
  id?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  rows?: number
  maxlength?: number
  error?: string
  hint?: string
  name?: string
  /** Sized by `rows` alone, for short answers: no minimum height, less padding. */
  compact?: boolean
}>(), {
  rows: 6,
})

const model = defineModel<string>()

// useId() matches between the server render and the browser; a random id did not (hydration mismatch).
const fallbackId = `sofax-textarea-${useId()}`
const inputId = computed(() => props.id || fallbackId)
</script>

<template>
  <div>
    <label v-if="label" :for="inputId" class="field-label">
      {{ label }}<span v-if="required" class="text-accent"> *</span>
    </label>
    <textarea
      :id="inputId"
      v-model="model"
      :name="name"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :rows="rows"
      :maxlength="maxlength"
      :aria-invalid="error ? 'true' : undefined"
      class="field-textarea"
      :class="{ 'field-error': !!error, '!min-h-0 !py-3': compact }"
    />
    <span v-if="error" class="field-hint !text-red-600 dark:!text-red-400">{{ error }}</span>
    <span v-else-if="hint" class="field-hint">{{ hint }}</span>
  </div>
</template>
